



























































import { Vue, Component, Prop } from 'vue-property-decorator'
import { IScale } from '../../../types/interfaces'
import Radio from '../Radio/Radio.vue'
import { ScaleAnswer } from '../../../../../shared/src/types/scaleAnswer'

interface ScaleOption {
  value: string | number;
  uid: string | number;
  label: string;
}

@Component({
  components: {
    Radio
  }
})
export default class Scale extends Vue {
  @Prop({ required: true }) scale!: IScale;
  @Prop({ required: true }) name!: string;

  optionGroupUID = Math.round(Math.random() * 100000);

  selectedOption = '';

  innerWidth = window.innerWidth;

  ScaleAnswer = ScaleAnswer

  updateInnerWidth () {
    this.innerWidth = window.innerWidth
  }

  mounted () {
    window.addEventListener('resize', this.updateInnerWidth)
  }

  destroyed () {
    window.removeEventListener('resize', this.updateInnerWidth)
  }

  get dropdownSelect () {
    const overLimit = this.scale.maxRating - this.scale.minRating > 6
    const mobileDevice = this.innerWidth < 600 // TODO: confirm this breakpoint
    return overLimit && mobileDevice
  }

  get optionGroupName () {
    return `${name}-${this.optionGroupUID}`
  }

  get scaleOptions (): ScaleOption[] {
    const { minRating, maxRating, minLabel, maxLabel } = this.scale
    const options = []
    for (let i = minRating; i < maxRating + 1; i++) {
      let label = `${i}`

      if (i === minRating && this.dropdownSelect) {
        label += ` - ${minLabel}`
      } else if (i === maxRating && this.dropdownSelect) {
        label += ` - ${maxLabel}`
      }

      options.push({
        label,
        value: i,
        uid: this.scaleOptionUID(i)
      })
    }
    return options
  }

  get hasNotApplicable () {
    return this.scale.naOption
  }

  scaleOptionUID (scaleOption: string | number): string {
    return `${this.name}-${scaleOption}-${this.optionGroupUID}`
  }

  newSelectInput () {
    const selectElement = this.$refs.select as HTMLSelectElement
    selectElement.classList.add('option-selected')
    this.$emit('input', this.selectedOption)
  }

  newScaleInput (selectedOption: string) {
    this.selectedOption = selectedOption
    this.$emit('input', this.selectedOption)
  }
}
